<template>
  <div class="header">
    <div class="header-container">
      <img src="@/assets/logo.png" class="logo" @click="backHome">
      <div class="label" @click="$router.replace('/')">山东省道路运输行业继续教育</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  methods: {
    backHome() {
      location.href = 'http://sd.anjia365.com/'
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  height: 120px;
  background-color: #4176e1;
  padding: 0 40px;
  .header-container {
    height: 120px;
    margin: 0 auto;
    max-width: 1200px;
    min-width: 850px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .label {
      font-size: 40px;
      font-weight: 700;
      color: #fff;
      cursor: pointer;
    }
  }
}
</style>
